export const BEFORE_VALIDATION             = 'BEFORE_VALIDATION';
export const AFTER_VALIDATION              = 'AFTER_VALIDATION';
export const BEFORE_SUBMIT                 = 'BEFORE_SUBMIT';
export const AFTER_SUBMIT                  = 'AFTER_SUBMIT';
export const START_DRAGGING                = 'START_DRAGGING';
export const END_DRAGGING                  = 'END_DRAGGING';
export const TAG_UPDATED                   = 'TAG_UPDATED';
export const EVENT_TIME_CREATED            = 'EVENT_TIME_CREATED';
export const POP_STATE                     = 'POP_STATE';
export const AJAX_ACCECCING                = 'AJAX_ACCECCING';
export const AJAX_ACCECCED                 = 'AJAX_ACCECCED';

export const GOTO_THE_COMMENT              = 'GOTO_THE_COMMENT';
export const GOTO_COMMENT_FORM             = 'GOTO_COMMENT_FORM';
export const GOTO_THE_HISTORY              = 'GOTO_THE_HISTORY';
// PLANNER
export const PLANNER_CLICK_CELL                   = 'PLANNER_CLICK_CELL';
export const PLANNER_OVER_SCHEDULE                = 'PLANNER_OVER_SCHEDULE';
export const PLANNER_SHOW_SCHEDULE_TT             = 'PLANNER_SHOW_SCHEDULE_TT';
export const PLANNER_OUT_SCHEDULE                 = 'PLANNER_OUT_SCHEDULE';
export const PLANNER_HIDE_SCHEDULE_TT             = 'PLANNER_HIDE_SCHEDULE_TT';
export const PLANNER_OVER_ORDERS_PHASE            = 'PLANNER_OVER_ORDERS_PHASE';
export const PLANNER_SHOW_ORDERS_PHASE_TT         = 'PLANNER_SHOW_ORDERS_PHASE_TT';
export const PLANNER_OUT_ORDERS_PHASE             = 'PLANNER_OUT_ORDERS_PHASE';
export const PLANNER_HIDE_ORDERS_PHASE_TT         = 'PLANNER_HIDE_ORDERS_PHASE_TT';
export const PLANNER_CLICK_SCHEDULE               = 'PLANNER_CLICK_SCHEDULE';
export const PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE = 'PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE';
export const PLANNER_CLOSE_DIALOG_SAVE_TASKS_MEMO = 'PLANNER_CLOSE_DIALOG_SAVE_TASKS_MEMO';
export const PLANNER_DRAG_SCHEDULE                = 'PLANNER_DRAG_SCHEDULE';
export const PLANNER_CLICK_START_LEFT             = 'PLANNER_CLICK_START_LEFT';
export const PLANNER_CLICK_START_RIGHT            = 'PLANNER_CLICK_START_RIGHT';
export const PLANNER_CLICK_END_LEFT               = 'PLANNER_CLICK_END_LEFT';
export const PLANNER_CLICK_END_RIGHT              = 'PLANNER_CLICK_END_RIGHT';
export const PLANNER_DRAG_START                   = 'PLANNER_DRAG_START';
export const PLANNER_DRAG_END                     = 'PLANNER_DRAG_END';
export const PLANNER_CLICK_MEMO                   = 'PLANNER_CLICK_MEMO';
export const PLANNER_CMD_CANCEL_DESTROY_SCHEDULE  = 'PLANNER_CMD_CANCEL_DESTROY_SCHEDULE';
export const PLANNER_CLICK_LINE_MENU              = 'PLANNER_CLICK_LINE_MENU';
export const PLANNER_CLICK_REMOVE_LINE            = 'PLANNER_CLICK_REMOVE_LINE';
export const PLANNER_CLICK_ADD_LINE               = 'PLANNER_CLICK_ADD_LINE';
export const PLANNER_SCROLL_SET_GETTERS           = 'PLANNER_SCROLL_SET_GETTERS';
export const PLANNER_SCROLL_TAB_POSITION          = 'PLANNER_SCROLL_TAB_POSITION';
export const PLANNER_SCROLL_CONTENT_POSITION      = 'PLANNER_SCROLL_CONTENT_POSITION';
export const PLANNER_SCROLL_UPDATED               = 'PLANNER_SCROLL_UPDATED';
export const PLANNER_SCROLL_CHANGE_NATIVES        = 'PLANNER_SCROLL_CHANGE_NATIVES';
export const PLANNER_SCROLL_SCROLL                = 'PLANNER_SCROLL_SCROLL';
export const PLANNER_SELECT_START_DATE            = 'PLANNER_SELECT_START_DATE';
export const PLANNER_CLICK_BACK_SCHEDULE          = 'PLANNER_CLICK_BACK_SCHEDULE';
export const PLANNER_CLICK_FORWARD_SCHEDULE       = 'PLANNER_CLICK_FORWARD_SCHEDULE';
export const PLANNER_CLICK_PARTITION              = 'PLANNER_CLICK_PARTITION';
export const PLANNER_CLICK_SEARCH_COLLAPSE        = 'PLANNER_CLICK_SEARCH_COLLAPSE';
export const PLANNER_CLICK_UNDER                  = 'PLANNER_CLICK_UNDER';
export const PLANNER_CLICK_STATUS                 = 'PLANNER_CLICK_STATUS';
export const PLANNER_CHANGE_UNDER                 = 'PLANNER_CHANGE_UNDER';
export const PLANNER_CHANGE_STATUS                = 'PLANNER_CHANGE_STATUS';
export const PLANNER_SUBMIT_UNDER                 = 'PLANNER_SUBMIT_UNDER';
export const PLANNER_SUBMIT_STATUS                = 'PLANNER_SUBMIT_STATUS';
export const PLANNER_CLICK_PIN                    = 'PLANNER_CLICK_PIN';
// COMMENT
export const COMMENT_CLICK_REMOVE        = 'COMMENT_CLICK_REMOVE';
export const COMMENT_CLICK_REPLY         = 'COMMENT_CLICK_REPLY';

export const DELIVERY_SELECT_START_DATE  = 'DELIVERY_SELECT_START_DATE';
export const DELIVERY_CLICK_DOWNLOAD     = 'DELIVERY_CLICK_DOWNLOAD';
export const DELIVERY_CLICK_LABELS       = 'DELIVERY_CLICK_LABELS';
export const DELIVERY_CLICK_LETTER       = 'DELIVERY_CLICK_LETTER';
export const DELIVERY_CLICK_SAVE         = 'DELIVERY_CLICK_SAVE';
export const DELIVERY_CLICK_EACH_SAVE    = 'DELIVERY_CLICK_EACH_SAVE';
// APPROVAL
// export const APPROVAL_CLICK_STAMP        = 'APPROVAL_CLICK_STAMP';
export const APPROVAL_CLICK_REQUIRE      = 'APPROVAL_CLICK_REQUIRE';
export const NOTIFICATION_READ           = 'NOTIFICATION_READ';
